<template>
  <div>
    <b-row>
      <b-col>
        <header-view
          :title="$t('message.adminContractPartnerTemplateDetails.title')"
          icon="ti-agenda">
        </header-view>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-card class="rounded-0">
          <admin-contract-partner-form
            @onCancel="cancel"
            @onDelete="deleteContractPartnerTemplate"
            @onSave="saveContractPartnerTemplate">
          </admin-contract-partner-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import AdminContractPartnerForm from '@/components/admin/AdminContractPartnerForm'
  import HeaderView from '@/components/common/HeaderView'
  export default {
    name: 'AdminContractPartnerTemplateDetails',
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (to.params && to.params.id) {
          vm.$store.dispatch('fetchAdminContractPartnerTemplateById', parseInt(to.params.id))
            .catch(() => {
              vm.showErrorMsg({
                message: vm.$t('error.adminContractPartnerTemplateDetails.fetchContractPartnerTemplateById')
              })
              vm.$router.replace('/admin/contractpartners')
            })
        } else {
          vm.$router.replace('/admin/contractpartners')
        }
      })
    },
    components: {
      AdminContractPartnerForm,
      HeaderView
    },
    computed: {
      contractPartner () {
        return this.$store.getters.adminContractPartner
      }
    },
    methods: {
      cancel () {
        this.$router.push('/admin/contractpartners')
      },
      deleteContractPartnerTemplate () {
        this.$store.dispatch('deleteAdminContractPartnerTemplate', this.contractPartner)
          .then(() => {
            this.showSuccessMsg({
              message: this.$t('message.adminContractPartnerTemplateDetails.deleteContractPartnerTemplate')
            })
            this.$router.push('/admin/contractpartners')
          })
          .catch(() => this.showErrorMsg({
            message: this.$t('error.adminContractPartnerTemplateDetails.deleteContractPartnerTemplate')
          }))
      },
      saveContractPartnerTemplate () {
        this.$store.dispatch('storeAdminContractPartnerTemplate', this.contractPartner)
          .then(() => {
            this.showSuccessMsg({
              message: this.$t('message.adminContractPartnerTemplateDetails.saveContractPartnerTemplate')
            })
            this.$router.push('/admin/contractpartners')
          })
          .catch(() => this.showErrorMsg({
            message: this.$t('message.adminContractPartnerTemplateDetails.saveContractPartnerTemplate')
          }))
      }
    },
    notifications: {
      showErrorMsg: {
        type: 'error'
      },
      showSuccessMsg: {
        type: 'success'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminContractPartnerTemplateDetails.vue